/**
 * Native shadow styles per view. Applied via the Pressable's
 * `nativeProps.style` on React Native — NativeWind v4 can't compile the
 * web-only `web:shadow-card*` box-shadow tokens (the grid one even carries an
 * inset highlight, which RN has no equivalent for). Values mirror the drop
 * component of the Figma "Cards Updated" shadows (frame 3153:44267):
 * grid 0/2 blur 4 @ 6%, list "Shadow-Secondary" 0/2 blur 8 @ 6%.
 *
 * NO `elevation` — the DS convention (see FOLDER_PREVIEW_NATIVE_SHADOW):
 * Android degrades shadowless. Both card surfaces are TRANSLUCENT
 * (`CARD_SURFACE_ALPHA` 0.8 / 0.7), and Android casts an elevation shadow
 * from an opaque, UNROUNDED copy of the view's bounds — on a see-through
 * card that copy shows through as a hard-cornered light rectangle inside
 * the rounded row. iOS derives its layer shadow from the composited alpha
 * and is unaffected, so the shadow* props below stay.
 */
/** Native shadows are cast in black; the opacity sets the strength. */
const SHADOW_COLOR = '#000000';

export const CARD_NATIVE_SHADOW = {
  grid: {
    shadowColor: SHADOW_COLOR,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 2,
  },
  list: {
    shadowColor: SHADOW_COLOR,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 4,
  },
} as const;

/**
 * The picked-up lift of a native drag ghost — card-dnd, rail-dnd and the
 * deck's media drags share it. Legacy shadow props on purpose, NOT
 * `boxShadow`: with no backgroundColor on the ghost wrapper iOS derives a
 * CALayer shadow from the content's composited alpha (a folder casts a
 * folder-shaped shadow); `boxShadow` would draw the wrapper's rectangle.
 * Web mirrors this with `drop-shadow`.
 */
export const DRAG_LIFT_NATIVE_STYLE = {
  shadowColor: SHADOW_COLOR,
  shadowOffset: { width: 0, height: 8 },
  shadowOpacity: 0.12,
  shadowRadius: 8,
  elevation: 12,
  opacity: 0.95,
} as const;

/** The original stays in place, dimmed, while its ghost is carried. */
export const DRAG_SOURCE_OPACITY = 0.4;
